import illustration_p1 from "./../../assets/images/Illustration_P1.png"
import contractCoveragePR2 from "../../assets/images/contract-coverage-pr2.png";
import p2Alerts from './../../assets/images/P2alerts.svg';
import graph from "./../../assets/images/graph-new.svg";
import high from "./../../assets/images/HighP2Alert.svg";
import medium from "./../../assets/images/MediumP2Alert.svg";
import { alertDetailAPI, normDetailsAPI } from "../api/api";
import { contractDetailsAPI, contractDetailsPR2API } from "../api/ContractConverageAPI";
import NormAlertTable from "../pages/Alerts/AlertTables/normAlert";
import ManpowerShortageTable from "Samarth Module/pages/Alerts/AlertTables/manpowerShortageTable";
import ContractAlertTable from 'Samarth Module/pages/Alerts/AlertTables/contractAlertTable';
import basepackImpacted from "./../../assets/images/basepackImpacted_agileOr.svg"
import p1Alerta from "./../../assets/images/p1Alert_agileOr.svg"
import alertStatusa from "./../../assets/images/alertStatus_agileOr.svg"
import illutrationMaterial from "./../../assets/images/Illustration_Material.png"
import alertStatus from "./../../assets/images/alert_status.svg"
import { aglieOR, weeklyOR, manpowerShortageAPI } from '../api/mdApi';
import RMPMAlertTable from 'Samarth Module/pages/Alerts/AlertTables/rmpmAlertTable';
import MAITable from 'Samarth Module/pages/Alerts/AlertTables/MAITable';
import OpenPOTable from 'Samarth Module/pages/Alerts/AlertTables/OpenPOTable'

// KPI configurations
export const KPI_CONFIG = {
  'RMPM Alert': [
    {
      label: "Total RMPM shortage alerts",
      img: p2Alerts
    },
    {
      label: "Total Materials Impacted",
      img: medium
    },
    {
      label: "MAI",
      img: p2Alerts
    },
    {
      label: "CBU Coverage %",
      img: illustration_p1
    },
    {
      label: "Alert Status",
      values: {
        Total: 0,
        Accepted: 0,
        Closed: 0
      }
    },
    {
      label: "Stock to norm (P2) alerts",
      img: high
    },
    {
      label: "Over stocking",
      img: p2Alerts
    },
    {
      label: "Stock to Norm",
      img: medium
    }
    
  ],
  'Contract Alert': [
    {
      label: "Contract coverage Wk1 (P1)",
      img: high
    },
    {
      label: "Contract coverage %",
      img: medium
    },
    {
      label: "PR to PO conversion",
      img: p2Alerts,
    },
    {
      label: "Alert Status",
      values: {
        Overdue: 0,
        Closed: 0,
        Accepted: 0,
        Total: 0
      }
    }
  ],
  'Contract PR2 Alert': [
    {
      label: "Contract coverage Wk1+i(P2)",
      img: high
    },
    {
      label: "Root cause loss tree",
      img: contractCoveragePR2,
      values: {
        "FSI not available": 0,
        "Validity expired": 0,
        "About to expire": 0,
        "Insufficient value": 0,
        "Insufficient quantity": 0,
        "Total": 0
      }
    }
  ],

  'Agile OR': [
    {
      label: "Agile OR (P1) alert",
      img: p1Alerta
    },
    {
      label: "Basepack impacted",
      img: basepackImpacted
    },
    {
      label: "CBUs impacted",
      value: {
        imcbu: 0,
        hpcbu: 0,
      }
    },
    // {
    //   label: "High priority CBU",
    //   img: highPriority
    // },
    {
      label: "WTD OR % || Agile OR %",
      value: {
        wtd: 0,
        agileor: 0
      }
    },
    {
      label: "Alert Status",
      img: alertStatusa,
      values: {
        Overdue: 0,
        Closed: 0,
        Accepted: 0,
        Total: 0
      }
    }
  ],
  'Or Loss Tree': [
    {
      label: "OR%",
      img: illutrationMaterial

    },
    {
      label: "Plan",
      img: illustration_p1

    },
    {
      label: "OR Loss",
      img: alertStatus

    },

  ],
  'FG Coverage': [
    {
      label: "FG Coverage",
      values: {
        Optimal: 0,
        Moderate: 0,
        Critical: 0,
      }
    },
    {
      label: "FG Coverage (Priority)",
      values: {
        Lean: 0,
        Agile: 0,
        Nurture: 0,
        Star: 0,
      }
    },
    {
      label: "Segmentation",
      values: {
        Low: 0,
        Medium: 0,
        High: 0,
      }
    }
  ],
  'Manpower Shortage': [
    {
      label: "Man power shortage alerts",
      img: p2Alerts
    },
    {
      label: "Predictive production loss",
      img: graph
    },
    {
      label: "Predicted accuracy",
      values: {
        "Week N+4": 0,
        "Week N+3": 0,
        "Week N+2": 0,
        "Week N+1": 0
      }
    },
  ],
};

// UI configurations
export const UI_CONFIG = {
  "RMPM Alert": {
    showKPI: true,
    showFooter: true,
    showReviewCart: true,
    showActionPopup: true,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    showToogleButton: true,
    showAcceptButton: true,
    showRejectButton: true,
    showSubmitButton: false,
    showActionHistory: true,
    showUnderlyingData: false,
    toggleBtn: ["Detailed view", "MAI View", "FG Coverage","Open PO Details", "Stock to Norm"],
  },
  "Norm Alert": {
    showKPI: true,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: false,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    containerClass: "fullHeightNorm",
    showToogleButton: false,
    showActionHistory: false,
    showUnderlyingData: false,
    toggleBtn: [],
  },
  "Contract Alert": {
    showKPI: true,
    showFooter: true,
    showReviewCart: false,
    showActionPopup: true,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    containerClass: "fullHeightContract",
    showToogleButton: false,
    showAcceptButton: true,
    showRejectButton: true,
    showSubmitButton: false,
    showActionHistory: true,
    showUnderlyingData: true,
    toggleBtn: [],
  },
  "Contract PR2 Alert": {
    showKPI: true,
    showFooter: false,
    showReviewCart: true,
    showActionPopup: true,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    containerClass: "fullHeight",
    showToogleButton: false,
    showActionHistory: false,
    showUnderlyingData: true,
    toggleBtn: [],
  },
  "Agile OR": {
    showKPI: true,
    showFooter: true,
    showReviewCart: true,
    showActionPopup: true,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    showToogleButton: false,
    showAcceptButton: true,
    showRejectButton: true,
    showSubmitButton: false,
    showActionHistory: true,
    showUnderlyingData: false,
    toggleBtn: [],
  },
  "Weekly OR": {
    showKPI: false,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: true,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    containerClass: "fullHeightWeekly",
    showToogleButton: false,
    showActionHistory: false,
    showUnderlyingData: false,
    toggleBtn: [],
  },
  "Or Loss Tree": {
    showKPI: true,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: false,
    showCustomizeColumns: true,
    showMoreFilters: false,
    showChatBot: true,
    containerClass: "fullHeight",
    showToogleButton: false,
    showActionHistory: false,
    showUnderlyingData: false,
    toggleBtn: [],
  },
  "FG Coverage": {
    showKPI: true,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: true,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    showToogleButton: true,
    containerClass: "fullHeightFgCoverage",
    showActionHistory: false,
    showUnderlyingData: false,
    toggleBtn: ["Percentage", "Absolute"],
  },
  "Manpower Shortage": {
    showKPI: true,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: false,
    showCustomizeColumns: true,
    showMoreFilters: true,
    showChatBot: true,
    showToogleButton: false,
    showActionHistory: false,
    showUnderlyingData: false,
    containerClass: "fullHeightSupplierInsights",
    toggleBtn: [],
  },
  "Supplier Insights": {
    showKPI: false,
    showFooter: false,
    showReviewCart: false,
    showActionPopup: false,
    showCustomizeColumns: false,
    showMoreFilters: true,
    showChatBot: false,
    showToogleButton: false,
    showActionHistory: false,
    showUnderlyingData: false,
    toggleBtn: [],
  },
};

// API configurations
export const API_CONFIG = {
  'RMPM Alert': {
    apiFunction: alertDetailAPI,
    tableComponent: RMPMAlertTable,
    tableComponent2: MAITable,
    tableComponent3: NormAlertTable,
    tableComponent4:OpenPOTable,
    tableComponent5: NormAlertTable
  },
  'Norm Alert': {
    apiFunction: normDetailsAPI,
    tableComponent: NormAlertTable
  },
  'Contract Alert': {
    apiFunction: contractDetailsAPI,
    tableComponent: ContractAlertTable
  },
  'Contract PR2 Alert': {
    apiFunction: contractDetailsPR2API,
    tableComponent: ContractAlertTable
  },
  'Agile OR': {
    apiFunction: aglieOR,
    tableComponent: RMPMAlertTable
  },
  'Weekly OR': {
    apiFunction: weeklyOR,
    tableComponent: NormAlertTable
  },
  'Or Loss Tree': {
    apiFunction: weeklyOR,
    tableComponent: NormAlertTable
  },
  // 'FG Coverage': {
  //   apiFunction: fgCoverageAPI,
  //   tableComponent: NormAlertTable,
  //   tableComponent2: NormAlertTable
  // },
  'Manpower Shortage': {
    apiFunction: manpowerShortageAPI,
    tableComponent: ManpowerShortageTable
  },
};

// Helper function to get configuration
export const getAlertConfig = (alertType) => {
  return {
    kpiDetails: KPI_CONFIG[alertType] || [],
    uiConfig: UI_CONFIG[alertType] || {
      showFooter: false,
      showReviewCart: false,
      showActionPopup: false,
      showCustomizeColumns: false,
      showMoreFilters: false,
      showSubmitButton: false,
      showAcceptButton: false,
      showRejectButton: false,
      showActionHistory: false,
      showUnderlyingData: false,
    },
    apiConfig: API_CONFIG[alertType] || {}
  };
};